import { render, staticRenderFns } from "./pedidos_productos.vue?vue&type=template&id=4bf67a8e&"
import script from "./pedidos_productos.vue?vue&type=script&lang=js&"
export * from "./pedidos_productos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports